import { IWalletEvent, IWalletEventMetadata, IWalletEventTicketCode } from 'meta/pages/v4/wallet'
import { SliceSelector } from 'store/types'

const getWalletPastEvents: SliceSelector<Record<number, Array<IWalletEvent>>> = () => (state) =>
  state.pages.wallet.events.past

const getWalletUpcomingEvents: SliceSelector<Record<number, Array<IWalletEvent>>> = () => (state) =>
  state.pages.wallet.events.upcoming

const getWalletPastGoodsServices: SliceSelector<Record<number, Array<IWalletEvent>>> = () => (state) =>
  state.pages.wallet.goodsServices.past

const getWalletUpcomingGoodsServices: SliceSelector<Record<number, Array<IWalletEvent>>> = () => (state) =>
  state.pages.wallet.goodsServices.upcoming

const getWalletEventTicketCodes: SliceSelector<
  Array<IWalletEventTicketCode> | undefined,
  { eventIdOrCodeUrl: string }
> =
  ({ eventIdOrCodeUrl }) =>
  (state) =>
    state.pages.wallet.events.tickets.codes[eventIdOrCodeUrl]?.items

const getWalletEventTicketCodesMetadata: SliceSelector<
  IWalletEventMetadata | undefined,
  { eventIdOrCodeUrl: string }
> =
  ({ eventIdOrCodeUrl }) =>
  (state) =>
    state.pages.wallet.events.tickets.codes[eventIdOrCodeUrl]?.metadata

const getWalletPastEventsMetadata: SliceSelector<IWalletEventMetadata> = () => (state) =>
  state.pages.wallet.events.metadata.past

const getWalletUpcomingEventsMetadata: SliceSelector<IWalletEventMetadata> = () => (state) =>
  state.pages.wallet.events.metadata.upcoming

const getWalletPastGoodsServicesMetadata: SliceSelector<IWalletEventMetadata> = () => (state) =>
  state.pages.wallet.goodsServices.metadata.past

const getWalletUpcomingGoodsServicesMetadata: SliceSelector<IWalletEventMetadata> = () => (state) =>
  state.pages.wallet.goodsServices.metadata.past

export const WalletSelectors = {
  getWalletPastEvents,
  getWalletUpcomingEvents,
  getWalletEventTicketCodes,
  getWalletPastGoodsServices,
  getWalletUpcomingGoodsServices,
  getWalletPastEventsMetadata,
  getWalletUpcomingEventsMetadata,
  getWalletPastGoodsServicesMetadata,
  getWalletUpcomingGoodsServicesMetadata,
  getWalletEventTicketCodesMetadata,
}
